"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copyText = copyText;
exports.toast = toast;
exports.showPosterShare = showPosterShare;
const tslib_1 = require("tslib");
const copy = require("copy-to-clipboard");
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const { useToast } = require('@fegobull/webapi').use;
const Toast = useToast();
/**
 * 复制文本到剪贴板
 * @param text 要复制的文本
 */
function copyText(text) {
    copy(text);
}
/**
 * 显示提示信息
 * @param msg 提示信息
 */
function toast(msg) {
    if (!msg) {
        return;
    }
    Toast.success(msg);
}
/**
 * 唤起海报分享
 * @param poster 海报图片URL或base64
 */
async function showPosterShare(poster) {
    var _a;
    if (!poster) {
        toast('海报图片不存在');
        return;
    }
    if (!((_a = nnq_1.default === null || nnq_1.default === void 0 ? void 0 : nnq_1.default.bridge) === null || _a === void 0 ? void 0 : _a.callHandler)) {
        toast('分享功能不可用');
        return;
    }
    const params = {
        show_type: 1, // ShowType.ImageShare
        enable: 0, // 启用所有分享渠道
        share_image: {
            images: [
                {
                    img: poster,
                    description: ''
                }
            ]
        }
    };
    return new Promise((resolve, reject) => {
        try {
            nnq_1.default.bridge.callHandler('setShowShare', params, (responseData) => {
                if (typeof responseData === 'string') {
                    responseData = JSON.parse(responseData);
                }
                // result为0表示分享成功，为-1表示分享取消，其他为失败
                if ([0, -1].includes(Number(responseData.result))) {
                    resolve();
                }
                else {
                    reject(responseData);
                }
            });
        }
        catch (error) {
            toast('分享失败');
            reject(error);
        }
    });
}
//# sourceMappingURL=data:application/json;base64,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